/**
 * LEGACY - Modal Content Dialog JS
 */

window.addEventListener('DOMContentLoaded', function () {
	function createDialog(dialogClass) {
		const dialog = document.createElement('dialog');
		dialog.className = dialogClass;
		dialog.setAttribute('closedby', 'any');

		const closeDialog = () => {
			dialog.close();
			dialog.classList.add('dialog-closed');
			document.body.classList.remove('no-scroll');
		};

		const closeButton = document.createElement('button');
		closeButton.className = 'dialog-close';
		closeButton.innerHTML = '&#215;';
		closeButton.type = 'button';
		closeButton.addEventListener('click', closeDialog);
		dialog.appendChild(closeButton);

		return { dialog, closeDialog };
	}

	/**
	 * CTA Popup Block - dismissable .is-style-cta-popup
	 */
	const ctaPopups = document.querySelectorAll('.is-style-cta-popup');
	const activeCtaDialogs = [];
	if (ctaPopups.length) {
		ctaPopups.forEach((ctaPopup) => {
			const { dialog, closeDialog } = createDialog('dialog-modal-cta');

			if (ctaPopup.classList.contains('alignfull')) {
				dialog.classList.add('alignfull');
			}
			if (ctaPopup.classList.contains('on-scrolled')) {
				dialog.classList.add('dialog-open-on-scrolled');
			}

			ctaPopup.parentNode.insertBefore(dialog, ctaPopup);
			dialog.appendChild(ctaPopup);
			activeCtaDialogs.push(dialog);

			const buttons = ctaPopup.getElementsByClassName('wp-element-button');
			if (buttons.length) {
				[...buttons].forEach((button) => {
					button.addEventListener('click', closeDialog);
				});
			}

			if (ctaPopup.classList.contains('on-scrolled')) {
				let dialogOpened = false;
				const onScroll = () => {
					if (window.pageYOffset > 600 && !dialogOpened) {
						dialogOpened = true;
						dialog.showModal();
						dialog.classList.add('dialog-opened');

						const swipers = dialog.querySelectorAll('.carousel-swiper--pattern');
						swipers.forEach((swiperEl) => {
							const instance = swiperEl.swiper;
							if (instance?.autoplay) {
								instance.params.autoplay.delay = 3000;
								instance.update();
								instance.autoplay.start();
							}
						});
						window.removeEventListener('scroll', onScroll);
					}
				};
				window.addEventListener('scroll', onScroll, { passive: true });
			} else {
				dialog.showModal();
				dialog.classList.add('dialog-opened');
			}
		});

		// Single outside click handler for all CTA dialogs
		document.addEventListener('click', (e) => {
			if (e.target.closest('#onetrust-banner-sdk, #onetrust-pc-sdk')) return;
			activeCtaDialogs.forEach((dialog) => {
				if (!dialog.contains(e.target) && dialog.open) {
					dialog.close();
					dialog.classList.remove('dialog-opened');
					dialog.classList.add('dialog-closed');
				}
			});
		});
	}

	/**
	 * Modal Dialog Content - block editor variation
	 */
	const modalDialogs = document.querySelectorAll('.modal-content--variation');
	if (modalDialogs.length) {
		modalDialogs.forEach((modalDialog) => {
			const modalDialogButton = modalDialog.querySelector('.dialog-trigger');
			const modalDialogContent = modalDialog.querySelector('.dialog-content');
			if (!modalDialogButton || !modalDialogContent) return;

			const { dialog } = createDialog('dialog-modal');
			modalDialogContent.parentNode.insertBefore(dialog, modalDialogContent);
			dialog.appendChild(modalDialogContent);

			modalDialogButton.addEventListener('click', (e) => {
				e.preventDefault();
				dialog.showModal();
				document.body.classList.add('no-scroll');
			});

			dialog.addEventListener('click', (e) => {
				if (e.target === dialog) {
					dialog.close();
					document.body.classList.remove('no-scroll');
				}
			});

			if (modalDialogContent.id && window.location.hash === '#' + modalDialogContent.id) {
				dialog.showModal();
			}
		});
	}

	/**
	 * Convert href to data-video-url and add dialog-trigger class
	 */
	function convertLinksToDataVideoUrl() {
		document.querySelectorAll('.convert-to-data-video-url').forEach((figure) => {
			const anchor = figure.querySelector('a');
			if (anchor) {
				const videoUrl = anchor.getAttribute('href');
				anchor.setAttribute('data-video-url', videoUrl);
				anchor.classList.add('dialog-trigger');
				anchor.removeAttribute('href');
				anchor.setAttribute('role', 'button');
				anchor.setAttribute('tabindex', '0');
				figure.classList.add('modal-content--video');
			}
		});
	}
	convertLinksToDataVideoUrl();

	/**
	 * Convert WP Button with is-style-video to video modal trigger
	 */
	function convertWPButtonsToVideoTriggers() {
		document.querySelectorAll('.wp-block-button.is-style-video').forEach((btn) => {
			const link = btn.querySelector('.wp-block-button__link');
			if (link && link.getAttribute('href')) {
				const videoUrl = link.getAttribute('href');
				link.setAttribute('data-video-url', videoUrl);
				link.classList.add('dialog-trigger');
				link.removeAttribute('href');
				link.setAttribute('role', 'button');
				link.setAttribute('tabindex', '0');
				btn.classList.add('modal-content--video');
			}
		});
	}
	convertWPButtonsToVideoTriggers();

	/**
	 * Play video in modal - used in search.php
	 */
	const videoModals = document.querySelectorAll('.modal-content--video');
	if (videoModals.length) {
		videoModals.forEach((videoModal) => {
			const videoModalButton = videoModal.querySelector('.dialog-trigger');
			if (!videoModalButton) return;

			videoModalButton.addEventListener('click', (e) => {
				e.preventDefault();

				const videoModalContent = document.createElement('div');
				videoModalContent.className = 'dialog-content';

				let videoUrl = videoModalButton.getAttribute('data-video-url') || '';

				if (videoUrl.includes('vimeo.com')) {
					videoUrl += (videoUrl.includes('?') ? '&' : '?') + 'autoplay=1';
				}
				if (videoUrl.includes('youtube.com')) {
					videoUrl +=
						(videoUrl.includes('?') ? '&' : '?') + 'modestbranding=1&autoplay=1&rel=0';
				}

				const videoEmbed = document.createElement('iframe');
				videoEmbed.setAttribute('src', videoUrl);
				videoEmbed.setAttribute('frameborder', '0');
				videoEmbed.setAttribute(
					'allow',
					'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
				);
				videoEmbed.setAttribute('allowfullscreen', '');

				videoModalContent.appendChild(videoEmbed);

				const { dialog } = createDialog('dialog-modal-video');
				dialog.appendChild(videoModalContent);
				document.body.appendChild(dialog);
				dialog.showModal();

				const removeOnClick = () => {
					dialog.removeEventListener('click', removeOnClick);
					dialog.remove();
				};
				dialog.addEventListener('click', removeOnClick);
			});
		});
	}

	/**
	 * Iframe lightbox
	 */
	const iframeModals = document.querySelectorAll(
		'a.modal-content--iframe, .modal-content--iframe a, .iframeTrigger, .iFrameTrigger'
	);
	if (iframeModals.length) {
		iframeModals.forEach((iframeModal) => {
			const openIframe = (e) => {
				e.preventDefault();

				// Prefer data-iframe, then data-video-url, then href
				let url =
					iframeModal.getAttribute('data-iframe') ||
					iframeModal.getAttribute('data-video-url') ||
					iframeModal.getAttribute('href') ||
					'';
				if (!url) return;

				// Autoplay adjustments
				if (url.includes('vimeo.com')) {
					url += (url.includes('?') ? '&' : '?') + 'autoplay=1';
				} else if (url.includes('youtube.com') || url.includes('youtu.be')) {
					url += (url.includes('?') ? '&' : '?') + 'modestbranding=1&autoplay=1&rel=0';
				}

				const iframeElement = document.createElement('iframe');
				iframeElement.setAttribute('src', url);
				iframeElement.setAttribute(
					'allow',
					'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
				);
				iframeElement.setAttribute('allowfullscreen', '');

				const { dialog } = createDialog('dialog-modal-iframe');
				dialog.appendChild(iframeElement);
				document.body.appendChild(dialog);
				dialog.showModal();

				const removeOnClick = () => {
					dialog.removeEventListener('click', removeOnClick);
					dialog.remove();
				};
				dialog.addEventListener('click', removeOnClick);
			};

			iframeModal.addEventListener('click', openIframe);

			// Hash-triggered auto open (legacy parity)
			if (iframeModal.id && window.location.hash === '#' + iframeModal.id) {
				setTimeout(() => iframeModal.click(), 300);
			}
		});
	}

	/**
	 * Image lightbox
	 */
	const imageModals = document.querySelectorAll(
		'a.modal-content--image, .modal-content--image a'
	);
	if (imageModals.length) {
		imageModals.forEach((imageModal) => {
			imageModal.addEventListener('click', (e) => {
				e.preventDefault();

				const imageElement = document.createElement('img');
				imageElement.src = imageModal.href;

				const figureElement = document.createElement('figure');
				figureElement.className = 'dialog-image';
				figureElement.appendChild(imageElement);

				const { dialog } = createDialog('dialog-modal-image');
				dialog.appendChild(figureElement);
				document.body.appendChild(dialog);
				dialog.showModal();

				const removeOnClick = () => {
					dialog.removeEventListener('click', removeOnClick);
					dialog.remove();
				};
				dialog.addEventListener('click', removeOnClick);
			});
		});
	}
});
